import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLangOverlay } from "../context/LangOverlayContext";

const languages = [
  { code: "jp", shortKey: "language.jp.short", labelKey: "language.jp.label" },
  { code: "en", shortKey: "language.en.short", labelKey: "language.en.label" },
  { code: "pl", shortKey: "language.pl.short", labelKey: "language.pl.label" },
  { code: "de", shortKey: "language.de.short", labelKey: "language.de.label" },
];

function LanguageMenu({ dark = false }) {
  const { i18n, t } = useTranslation();
  const { triggerSwitch } = useLangOverlay();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const activeLanguage = languages.find((language) => language.code === i18n.resolvedLanguage) || languages[0];

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!menuRef.current?.contains(event.target)) setIsOpen(false);
    };

    document.addEventListener("pointerdown", closeOnOutsideClick);
    return () => document.removeEventListener("pointerdown", closeOnOutsideClick);
  }, []);

  const changeLanguage = (code) => {
    setIsOpen(false);
    triggerSwitch(code, () => i18n.changeLanguage(code));
  };

  return (
    <div ref={menuRef} className="relative">
      <button
        type="button"
        aria-expanded={isOpen}
        aria-label={t("language.select")}
        onClick={() => setIsOpen(!isOpen)}
        className={`flex h-[38px] items-center gap-[10px] rounded-[10px] px-[12px] font-[Inter] text-[13px] transition-colors ${dark ? "text-white hover:bg-white/10" : "text-[#3d4350] hover:bg-[#eef4fc]"}`}
      >
        <span>{t(activeLanguage.shortKey)}</span>
        <span className={`mt-[-4px] h-[8px] w-[8px] rotate-45 border-b border-r transition-transform ${isOpen ? "translate-y-[4px] rotate-[225deg]" : ""} ${dark ? "border-white" : "border-[#05193A]"}`} />
      </button>
      <div className={`absolute right-0 top-[calc(100%+8px)] z-[1000] w-[176px] origin-top-right rounded-[12px] border border-[#d8dfeb] bg-white p-[6px] shadow-[0_18px_48px_rgba(5,25,58,0.18)] transition ${isOpen ? "visible scale-100 opacity-100" : "invisible scale-95 opacity-0"}`}>
        {languages.map((language) => (
          <button
            key={language.code}
            type="button"
            onClick={() => changeLanguage(language.code)}
            className={`flex w-full items-center justify-between rounded-[8px] px-[12px] py-[10px] text-left font-['Nunito_Sans'] text-[14px] transition-colors ${language.code === activeLanguage.code ? "bg-[#DAEBFC] font-bold text-[#05193A]" : "text-[#05193A] hover:bg-[#eef4fc]"}`}
          >
            <span>{t(language.labelKey)}</span>
            <span className="text-[12px] font-light">{t(language.shortKey)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default LanguageMenu;
